/* global window,getPloaderSantaConfig */

import PackagesUtil from './lib/common/PackagesUtil.js'
import addExperimentsFromQuery from './lib/common/addExperimentsFromQuery.js'
import getFullRjsConfig from './lib/common/getFullRjsConfig.js'
import getQueryUtils from './lib/common/getQueryUtils.js'
import getSubdomain from './lib/common/getSubdomain.js'
import identifyForFullStory from './lib/editor/identifyForFullStory.js'
import instrument from './lib/editor/instrument.js'
import isLocal from './lib/common/isLocal.js'
import joinURL from './lib/common/joinURL.js'
import overrideScriptsLocationMapFromQuery from './lib/common/overrideScriptsLocationMapFromQuery.js'
import replaceUrlVersion from './lib/common/replaceUrlVersion.js'
import requirejs from 'requirejs'
import rjsConfig from './lib/editor/rjs-config.js'
import runEditor from './lib/editor/runEditor.js'
import storageUtil from './lib/common/storageUtil.js'

const options = require('json!./options/editor.json')

const queryUtil = getQueryUtils(window)

window.joinURL = joinURL
window.queryUtil = queryUtil
window.persistent = storageUtil(window) // TODO: how is this used?
window.identifyForFullStory = identifyForFullStory

if (window.customRenderSite !== undefined) { // allows to override this in other html files as starting points
  window.customRenderSite()
} else {
  render()
}


function render() {
  const getEditorRjsConfig = rjsConfig(window, options.versions, getPloaderSantaConfig)
  const packagesUtil = new PackagesUtil(options.packages, window.location.search)

  window.mainLoaded = Date.now()

  window.serviceTopology.mediaManagerUrl = replaceUrlVersion(window.serviceTopology.mediaManagerUrl, queryUtil.getParameterByName('mmgr'))
  window.serviceTopology.scriptsLocationMap = overrideScriptsLocationMapFromQuery(window.serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'))

  const editorModel = window.editorModel
  if (editorModel) {
    editorModel.runningExperiments = addExperimentsFromQuery(editorModel.runningExperiments, queryUtil, 'editor')
    editorModel.languageCode = queryUtil.getParameterByName('lang') || editorModel.languageCode
  }

  const config = getFullRjsConfig(
    'santa-editor',
    window.editorBase,
    getEditorRjsConfig(
      window.serviceTopology,
      editorModel,
      window.santaBase,
      PackagesUtil
    ),
    packagesUtil,
    window.serviceTopology
)

  if (editorModel) {
    editorModel.editorBase = config.baseUrl
    const semverMatches = config.baseUrl.match(/\/(\d+\.\d+\.\d+)\/?$/)
    editorModel.editorVersion = semverMatches && semverMatches[1]

    instrument(window, requirejs, queryUtil, editorModel)
    window.bi.event(458, { // main-r loaded event
      prefetch: window.afterEditorPrefetch
    })
  } else {
    instrument(window, requirejs, queryUtil)
    window.bi.event(588) // prefetch start
  }

  requirejs.config(config)

  try {
    window.document.domain = getSubdomain(window.document.domain)
  } catch (e) {
        // empty
  }

  if (isLocal(window.editorBase) && queryUtil.getParameterByName('hot') !== 'false') {
    requirejs(['hot', 'jquery'], (hot, $) => {
      hot.init($, false)
      runEditor(window, options.packages, requirejs, editorModel, queryUtil, config)
    })
  } else {
    runEditor(window, options.packages, requirejs, editorModel, queryUtil, config)
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/editor.js